function CloseMenuIcon() {
    return <svg width="45px" height="35px" viewBox="0 0 44.47 44.47">
    <polygon className="cls-1" points="44.47 1.41 43.06 0 22.24 20.82 1.41 0 0 1.41 20.82 22.24 0 43.06 1.41 44.47 22.24 23.65 43.06 44.47 44.47 43.06 23.65 22.24 44.47 1.41"/>
  </svg>
}

export default CloseMenuIcon